import localForage from 'localforage'

export default {

    surveys: localForage.createInstance({
        name: 'surveys'
    }),

    files: localForage.createInstance({
        name: 'files'
    }),

    referencenumbers: localForage.createInstance({
        name: 'referencenumbers'
    }),

    async getSurveyItem(key: string) {

        return await this.surveys.getItem(key).then(value => value)
    },

    async getFilesItem(key: string) {

        return await this.files.getItem(key).then(value => value)
    },

    async getReferenceNumberItem(key: string) {

        return await this.referencenumbers.getItem(key).then(value => value)
    },

    async getAllSurveys() {

        let allSurveys: any = []

        this.surveys.iterate((value: any) => {

            allSurveys.push(value)
        })

        return allSurveys
    }
}